var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7275 9.1875V12.5625C12.7275 15.375 11.6025 16.5 8.79 16.5H5.415C2.6025 16.5 1.4775 15.375 1.4775 12.5625V9.1875C1.4775 6.375 2.6025 5.25 5.415 5.25H8.79C11.6025 5.25 12.7275 6.375 12.7275 9.1875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4775 5.625C16.4775 7.7775 14.835 9.54 12.7275 9.7275V9.1875C12.7275 6.375 11.6025 5.25 8.79 5.25H8.25C8.4375 3.1425 10.2 1.5 12.3525 1.5C14.445 1.5 16.17 3.0525 16.4325 5.0775C16.4625 5.25 16.4775 5.4375 16.4775 5.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M17.5 0.5V17.5H0.5V0.5H17.5Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.c6bf2fbdea83de06429e4bb79f813203.svg";
export { ForwardRef as ReactComponent };